// Ultima copia de algunas consultas en el navegador (por empresa y persona): al refrescar la pagina se ve al instante lo
// que habia y se actualiza por detras, en vez de esperar con la pantalla en gris. Se borra al cerrar sesion.
import { getSession } from '../api/http';
import { readJSON, remove, writeJSON } from './storage';

const PREFIJO = 'consola.cache.';
const clave = (k: string) => {
  const s = getSession();
  return `${PREFIJO}${s?.workspace.id ?? s?.workspace.nombre ?? ''}.${s?.email ?? s?.modo ?? ''}.${k}`;
};

export function leerCache<T>(k: string): { data: T; en: number } | undefined {
  const c = readJSON<{ data: T; en: number } | null>(clave(k), null);
  return c && typeof c.en === 'number' ? c : undefined;
}

export const guardarCache = (k: string, data: unknown) => writeJSON(clave(k), { data, en: Date.now() });

export function borrarCaches() {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (k?.startsWith(PREFIJO)) remove(k);
    }
  } catch {
    /* sin almacenamiento */
  }
}

// Para useQuery: queryFn que guarda la copia y datos iniciales tomados de ella (marcados con su fecha real, asi React
// Query los muestra y pide los frescos enseguida).
export function conCache<T>(k: string, fn: () => Promise<T>, paraGuardar: (d: T) => unknown = (d) => d) {
  return {
    queryFn: async () => {
      const d = await fn();
      guardarCache(k, paraGuardar(d));
      return d;
    },
    initialData: () => leerCache<T>(k)?.data,
    initialDataUpdatedAt: () => leerCache<T>(k)?.en,
  };
}
